import { Colors } from 'app/styles'

export const main = `0px 8px 144px ${Colors.black08}`
